import { DropdownPaginated } from 'components/commons';
import React, { useCallback } from 'react';
import { useApi } from 'hooks';
import { getCustomers } from 'apis/customer.api';

const SelectCustomer = ({ placeholder = '', hasAll = false, ...props }) => {
  const {
    request,
    loading,
    result = { customers: [], count: 0 }
  } = useApi({
    api: getCustomers,
    pageError: true
  });

  const fetch = useCallback(
    async (params) => {
      return await request({
        perPage: 10,
        ...params
      });
    },
    [request]
  );

  let otherOptions;
  if (hasAll) {
    otherOptions = { allOption: [{ label: 'All', value: null }] };
  }

  return (
    <DropdownPaginated
      {...props}
      request={async (params) => {
        return await fetch(params);
      }}
      total={result.count}
      loading={loading}
      formatRequest={(result) => {
        const { customers = [] } = result || {};
        if (customers && customers.length > 0) {
          const newCustomers = customers;

          return newCustomers.map((d) => {
            return {
              label: d.cifNumber,
              value: d.customerId
            };
          });
        }
        return [];
      }}
      placeholder={placeholder}
      {...otherOptions}
    />
  );
};

export default SelectCustomer;
